module.exports = __webpack_public_path__ + "static/media/connection_img.991c85a9.jpg";